import { message }          from 'antd';
import { messageErrorIntl } from 'utils/messageIntl';

const handleApiError = (error: any) => {
  if (error.connectorError && error.connectorError.response && error.connectorError.response.data) {
    if (error.connectorError.response.data.violations) {
      error.connectorError.response.data.violations.forEach((violation: any) => {
        if (violation.propertyPath) {
          message.error(`${violation.propertyPath}: ${violation.message}`);
        } else {
          message.error(violation.message);
        }
      });
    } else if (error.connectorError.response.data['hydra:description']) {
      return message.error(error.connectorError.response.data['hydra:description']);
    } else {
      messageErrorIntl("Une erreur s'est produite.");
    }
  } else {
    messageErrorIntl("Une erreur s'est produite.");
  }
};

export default handleApiError;
